/* unplugin-vue-components disabled */import { render } from "./GetStartedCard.vue?vue&type=template&id=3cba45ea&scoped=true&ts=true"
import script from "./GetStartedCard.vue?vue&type=script&lang=ts"
export * from "./GetStartedCard.vue?vue&type=script&lang=ts"

import "./GetStartedCard.vue?vue&type=style&index=0&id=3cba45ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cba45ea"]])

export default __exports__